import { LiveVideoSkinElement } from '../../presets/live-video/skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/default-live-video/register';

safeDefine(LiveVideoSkinElement);
